<script>
export default {
    name: "lemonMessageReply",
    inheritAttrs: false,
    inject: ["IMUI"],
    render() {
        return (
            <lemon-message-basic
                class="lemon-message-reply"
                props={{ ...this.$attrs }}
                scopedSlots={{
                    content: props => {
                        let replyMessage = props.replyMessage
                        const content = this.IMUI.emojiNameToImage(props.content);
                        let replyContent = this.IMUI.emojiNameToImage(replyMessage.content);
                        let replyUsername = replyMessage.fromUser.displayName
                        let repliedMsgCreateTime = replyMessage.originalMessage.createTime
                        return <div>
                            <div class='replied-msg'>
                                <p domProps={{ innerHTML: replyContent }} />
                                <p class='replied-time' domProps={{innerHTML: `${replyUsername} ${repliedMsgCreateTime}`}}/>
                            </div>
                            <span domProps={{ innerHTML: content }} />
                        </div>
                    }
                }}
            />
        );
    }
};
</script>
<style lang='css'>

.replied-msg {
    padding: 10px;
    color: #606266;
}

.replied-time {
    font-size: 11px;
}
</style>